import Image from "next/image";
import React from "react";
import { resolveImageSource } from "@repo/ui/helpers";
import unassignedDocImg from "@repo/ui/resources/avatars/kinsa/unassigned_doc.svg";
import type { AvatarAssetProps, AvatarBrandConfig } from "../avatar/brand-config";
import CatAvatar from "./avatar-assets/Cat";
import DinosaurAvatar from "./avatar-assets/Dinosaur";
import DogAvatar from "./avatar-assets/Dog";
import MonkeyAvatar from "./avatar-assets/Monkey";
import PenguinAvatar from "./avatar-assets/Penguin";
import RobotAvatar from "./avatar-assets/Robot";
import SharkAvatar from "./avatar-assets/Shark";
import UnicornAvatar from "./avatar-assets/Unicorn";

const KinsaUnassignedDoc: React.FC<AvatarAssetProps> = ({
  width = 80,
  height = 80,
  className = "",
}) => (
  <div style={{ width, height }} className={className}>
    <Image
      src={resolveImageSource(unassignedDocImg)}
      alt="Unassigned Doctor Avatar"
      width={width}
      height={height}
      unoptimized
    />
  </div>
);

export const avatarConfig: AvatarBrandConfig = {
  ringSecondAvatarWhenAssigned: false,
  UnassignedDoc: KinsaUnassignedDoc,
  variants: {
    monkey: MonkeyAvatar,
    cat: CatAvatar,
    unicorn: UnicornAvatar,
    shark: SharkAvatar,
    penguin: PenguinAvatar,
    robot: RobotAvatar,
    dinosaur: DinosaurAvatar,
    dog: DogAvatar,
  },
  CustomFallback: RobotAvatar,
};
